import { HelpLinkIFrame, ModalHeader, useModal } from '@wrisk/ui-components'
import React, { useCallback } from 'react'

import { ConditionalCover } from '../../../domain'
import {
  tCovers,
  useWriskTranslation,
} from '../../../infrastructure/internationalisation'
import { getExposuresContentBaseUrl, useConfig } from '../../../state/configuration'
import { useProduct } from '../../product/productContext'

export const useConditionalCoverModal = () => {
  const { t } = useWriskTranslation()
  const { show } = useModal()
  const { scheme } = useProduct()

  const contentBaseUrl = useConfig(getExposuresContentBaseUrl(scheme.schemeCode))

  return useCallback(
    (cover: ConditionalCover) => {
      cover.active
        ? show({
            content: <HelpLinkIFrame src={`${contentBaseUrl}/${cover.coverCode}.html`} />,
            variant: 'iframe',
          })
        : show({
            content: (
              <ModalHeader
                header={t(tCovers(cover.coverCode, 'unavailable', 'header'))}
                subheader={t(tCovers(cover.coverCode, 'unavailable', 'description'))}
              />
            ),
          })
    },
    [show, t, contentBaseUrl],
  )
}
